import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, SignIn } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_TOKEN_KEY = 'aafaq_admin_token';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || 'كلمة المرور غير صحيحة');
      }
      const data = await res.json();
      localStorage.setItem(ADMIN_TOKEN_KEY, data.token);
      toast.success('أهلاً بكِ');
      navigate('/admin/requests');
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      data-testid="admin-login-page"
      className="pt-24 pb-16 min-h-screen bg-[#F7F5F2] flex items-center"
      dir="rtl"
    >
      <div className="max-w-md mx-auto px-4 w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-[24px] shadow-sm border border-[#E6E0D6] p-8"
        >
          <div className="w-14 h-14 rounded-2xl bg-[#1F3D2B] flex items-center justify-center mb-5 mx-auto">
            <Lock size={28} weight="duotone" className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-[#1F3D2B] mb-2 text-center font-['IBM_Plex_Sans_Arabic']">
            لوحة الإدارة
          </h1>
          <p className="text-sm text-[#7A866E] text-center mb-6">
            أدخلي كلمة مرور الأدمن للوصول
          </p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="password">كلمة المرور</Label>
              <Input
                id="password"
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1 rounded-xl"
                dir="ltr"
              />
            </div>
            <Button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="w-full bg-[#1F3D2B] hover:bg-[#163020] text-white rounded-xl py-3 flex items-center justify-center gap-2"
            >
              <SignIn size={18} />
              {loading ? 'جاري الدخول...' : 'دخول'}
            </Button>
          </form>
        </motion.div>
      </div>
    </main>
  );
};

export default AdminLoginPage;
